export const DEBT_ACKNOWLEDGEMENT = 'debt_acknowledgement'
export const INSTALLMENT_PLAN = 'installment_plan'
export const SECURITY = 'security'
export const OTHER = 'other'

export const ALL_LEASE_DEBT_SETTLEMENT_TYPES = [
  DEBT_ACKNOWLEDGEMENT,
  INSTALLMENT_PLAN,
  SECURITY,
  OTHER,
] as const

export type LeaseDebtSettlementType =
  (typeof ALL_LEASE_DEBT_SETTLEMENT_TYPES)[number]
